import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const API_BASE_URL = 'https://dolphin-app-33jp4.ondigitalocean.app';

function MentorBox() {
  const navigate = useNavigate();
  const [hasRefAccess, setHasRefAccess] = useState(false);

  // ── Mirror Navbar refAccess logic ─────────────────────────────────────────
  useEffect(() => {
    const checkRefAccess = () => {
      try {
        const userData = localStorage.getItem('userData');
        const user = userData ? JSON.parse(userData) : null;
        if (user && (user.role === 'super_admin' || user.email === 'info@easylearn.net.in')) {
          setHasRefAccess(true);
        } else {
          setHasRefAccess(localStorage.getItem('refAccess') === '1');
        }
      } catch {
        setHasRefAccess(false);
      }
    };

    checkRefAccess();

    const pollRefAccess = async () => {
      try {
        const userData = localStorage.getItem('userData');
        if (!userData) return;
        const user = JSON.parse(userData);
        if (!user?.email || user.role === 'super_admin' || user.email === 'info@easylearn.net.in') return;
        const res = await fetch(
          `${API_BASE_URL}/isfathena/user/can-access-reference?email=${encodeURIComponent(user.email)}`
        );
        const data = await res.json();
        const newVal = data.can_access ? '1' : '0';
        if (newVal !== localStorage.getItem('refAccess')) {
          localStorage.setItem('refAccess', newVal);
          setHasRefAccess(data.can_access);
        }
      } catch {}
    };

    const handleStorageEvent = (e) => {
      if (e.key === 'refAccessToggle') {
        try {
          const { email, value } = JSON.parse(e.newValue);
          const userData = localStorage.getItem('userData');
          if (userData) {
            const user = JSON.parse(userData);
            if (user.email === email) {
              localStorage.setItem('refAccess', value);
              setHasRefAccess(value === '1');
            }
          }
        } catch {}
      }
      checkRefAccess();
    };

    const pollInterval = setInterval(pollRefAccess, 10000);
    window.addEventListener('storage', handleStorageEvent);
    window.addEventListener('refAccessChange', checkRefAccess);

    return () => {
      clearInterval(pollInterval);
      window.removeEventListener('storage', handleStorageEvent);
      window.removeEventListener('refAccessChange', checkRefAccess);
    };
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => { e.preventDefault(); return false; };
    const handleKeyDown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J')) ||
        (e.ctrlKey && e.key === 'U')
      ) { e.preventDefault(); return false; }
    };
    const handleCopy = (e) => { e.preventDefault(); return false; };
    const handleDragStart = (e) => { e.preventDefault(); return false; };

    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('copy', handleCopy);
    document.addEventListener('dragstart', handleDragStart);
    document.body.style.userSelect = 'none';
    document.body.style.webkitUserSelect = 'none';
    document.body.style.msUserSelect = 'none';

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('copy', handleCopy);
      document.removeEventListener('dragstart', handleDragStart);
      document.body.style.userSelect = '';
      document.body.style.webkitUserSelect = '';
      document.body.style.msUserSelect = '';
    };
  }, []);

  return (
    <div className="bg-black text-white min-h-screen overflow-x-hidden w-full">
      <Navbar />

      {/* Protection styles */}
      <style jsx>{`
        img {
          pointer-events: none;
          user-select: none;
          -webkit-user-drag: none;
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
        }
        html, body {
          overflow-x: hidden;
          max-width: 100%;
        }
      `}</style>

      {/* Background stars */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
        {[...Array(80)].map((_, i) => (
          <div
            key={i}
            className="absolute bg-white rounded-full opacity-50"
            style={{
              width: Math.random() * 2 + 1 + 'px',
              height: Math.random() * 2 + 1 + 'px',
              top: Math.random() * 100 + '%',
              left: Math.random() * 100 + '%',
            }}
          />
        ))}
      </div>

      {/* ─── HERO SECTION ──────────────────────────────────────────────────── */}
      <section className="relative overflow-hidden min-h-[50vh] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="/Assests/home_page_184.png"
            alt="MentorBox Hero Background"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-black/55"></div>
        <div className="absolute bottom-0 left-0 w-1/2 h-1/2 bg-orange-900/20 blur-3xl pointer-events-none"></div>

        <div className="relative z-10 w-full max-w-4xl mx-auto px-4 sm:px-8 lg:px-10 text-center py-16 sm:py-20">
          <h1 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight">
            MentorBox Project Mentoring &amp; Management System
          </h1>
          <p className="text-gray-200 text-sm sm:text-base leading-relaxed max-w-2xl mx-auto mb-7 px-2">
            Empowering Startups &amp; Mentors with a unified platform for seamless collaboration,
            knowledge sharing, and accelerated growth.
          </p>
          <div className="flex flex-wrap gap-3 justify-center">
            <button className="px-6 py-3 bg-orange-500 text-black font-bold text-sm sm:text-base rounded-full hover:bg-orange-400 transition-all duration-200">
              Get Started Free
            </button>
            <button className="px-6 py-3 border-2 border-orange-500 text-orange-500 font-bold text-sm sm:text-base rounded-full bg-transparent hover:bg-orange-500 hover:text-black transition-all duration-200">
              Watch Demo
            </button>
          </div>
        </div>
      </section>

      {/* ─── CHAPTER 1: THE VISION ────────────────────────────────────────── */}
      <section className="relative overflow-hidden flex items-center">
        <div className="absolute inset-0">
          <img
            src="/Assests/home_page_185.png"
            alt="Chapter 1 Background"
            className="w-full h-full object-cover object-center"
          />
        </div>
        <div className="absolute inset-0 bg-black/65"></div>
        <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-orange-950/40 to-transparent pointer-events-none"></div>

        <div className="relative z-10 w-full px-4 sm:px-10 lg:px-20 py-14 sm:py-20 text-center">
          <h2 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white leading-tight max-w-4xl mx-auto">
            The Vision Behind MentorBox
          </h2>
        </div>
      </section>

      {/* ─── Mentoring Made Easy ─── */}
      <section className="relative px-4 sm:px-10 lg:px-20 py-12 sm:py-16 bg-black overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div key={i} className="absolute bg-white rounded-full"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
                opacity: Math.random() * 0.4 + 0.1,
              }}
            />
          ))}
        </div>

        <div className="max-w-5xl mx-auto relative z-10 text-center">
          <h2 className="text-xl sm:text-3xl lg:text-5xl font-bold text-white mb-4 sm:mb-5 leading-tight">
            Mentoring Made Easy for Entrepreneurs and Innovators
          </h2>
          <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-8 sm:mb-10 max-w-3xl mx-auto px-2">
            MentorBox is a powerful online platform that bridges the gap between ambitious startups
            and seasoned industry mentors. It creates a dynamic ecosystem where knowledge flows
            freely, meaningful discussions spark innovation, and shared goals become tangible achievements.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-5">
            {[
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M7 11.5V14m0-2.5v-6a1.5 1.5 0 113 0m-3 6a1.5 1.5 0 00-3 0v2a7.5 7.5 0 0015 0v-5a1.5 1.5 0 00-3 0m-6-3V11m0-5.5v-1a1.5 1.5 0 013 0v1m0 0V11m0-5.5a1.5 1.5 0 013 0v3m0 0V11" />
                ),
                title: 'Connect',
                desc: 'Match startups with expert mentors across industries',
              },
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                ),
                title: 'Collaborate',
                desc: 'Share knowledge through guided discussions and workshops',
              },
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                ),
                title: 'Scale',
                desc: 'Built for incubators, accelerators, colleges, and companies',
              },
            ].map((item) => (
              <div key={item.title} className="bg-gray-950 border border-orange-500 rounded-xl p-5 sm:p-6 text-left">
                <div className="w-10 h-10 sm:w-11 sm:h-11 bg-orange-500 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {item.icon}
                  </svg>
                </div>
                <h3 className="text-base font-bold text-white mb-2">{item.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── A Unified Platform ──────── */}
      <section className="relative px-4 sm:px-10 lg:px-20 py-12 sm:py-16 overflow-hidden" style={{ backgroundColor: '#c8641a' }}>
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(50)].map((_, i) => (
            <div key={i} className="absolute bg-orange-200 rounded-full"
              style={{
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
                opacity: Math.random() * 0.25 + 0.05,
              }}
            />
          ))}
        </div>

        <div className="max-w-5xl mx-auto relative z-10 text-center">
          <h2 className="text-xl sm:text-3xl lg:text-5xl font-bold text-white mb-4 sm:mb-5 leading-tight">
            A Unified Platform for Hassle-Free Mentorship
          </h2>
          <p className="text-orange-50 text-sm sm:text-base leading-relaxed mb-8 sm:mb-10 max-w-3xl mx-auto px-2">
            MentorBox eliminates the chaos of juggling multiple tools by bringing video conferencing,
            whiteboarding, file management, and communication into one seamless environment. The vision
            is clear: equip every startup with essential mentoring tools on a single, intuitive platform.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8">
            {[
              { img: '/Assests/home_page_184.png', title: 'Video Conferencing', desc: 'Live mentoring sessions with crystal-clear audio and video' },
              { img: '/Assests/home_page_185.png', title: 'Interactive Whiteboard', desc: 'Brainstorm and visualize ideas together in real time' },
              { img: '/Assests/home_page_186.png', title: 'Document Management', desc: 'Share, organize, and track files effortlessly' },
            ].map((item) => (
              <div key={item.title} className="flex flex-col">
                <div className="rounded-xl overflow-hidden mb-4 aspect-video">
                  <img src={item.img} alt={item.title} className="w-full h-full object-cover" style={{ filter: 'brightness(0.75)' }} />
                </div>
                <h3 className="text-white font-bold text-base mb-1">{item.title}</h3>
                <p className="text-orange-100 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── CHAPTER 2: CORE FEATURES ─────────────────────────── */}
      <section className="relative overflow-hidden flex items-center">
        <div className="absolute inset-0">
          <img src="/Assests/home_page_189.png" alt="Chapter 2 Background" className="w-full h-full object-cover object-center" />
        </div>
        <div className="absolute inset-0 bg-black/80"></div>
        <div className="absolute bottom-0 right-0 w-1/3 h-1/2 bg-orange-900/15 blur-3xl pointer-events-none"></div>

        <div className="relative z-10 w-full px-4 sm:px-10 lg:px-20 py-10 sm:py-14 text-center">
          <h2 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white leading-tight max-w-3xl mx-auto">
            Core Features That Transform Mentoring
          </h2>
        </div>
      </section>

      {/* ─── INTERACTIVE MENTORING TOOLS ── */}
      <section className="relative px-4 sm:px-10 lg:px-20 pt-8 pb-12 sm:pt-10 sm:pb-16 bg-black overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(70)].map((_, i) => (
            <div key={i} className="absolute bg-white rounded-full"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
                opacity: Math.random() * 0.35 + 0.08,
              }}
            />
          ))}
        </div>

        <div className="max-w-5xl mx-auto relative z-10 text-center">
          <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4">
            Interactive Mentoring Tools
          </h2>
          <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-10 sm:mb-14 max-w-3xl mx-auto px-2">
            MentorBox delivers a rich toolkit designed to make every mentoring session productive
            and engaging. From live video with embedded whiteboard collaboration to structured
            knowledge exchange forums, every interaction drives meaningful progress.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
            {[
              { num: '1', title: 'Live Video + Whiteboard', desc: 'Conduct real-time brainstorming sessions with embedded drawing and annotation tools' },
              { num: '2', title: 'Document Manager', desc: 'Upload, share, and track resources so nothing gets lost between sessions' },
              { num: '3', title: 'Discussion Forums', desc: 'Facilitate group discussions and knowledge exchange across teams and cohorts' },
            ].map((item) => (
              <div key={item.num} className="relative bg-gray-950 border border-orange-500 rounded-xl pt-10 pb-6 px-5 sm:px-6 mt-5 text-left">
                <div className="absolute -top-5 left-1/2 -translate-x-1/2 w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-bold text-base z-10 shadow-lg shadow-orange-900/50">
                  {item.num}
                </div>
                <h3 className="text-white font-bold text-base mb-3">{item.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── Project & Task Management ─── */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-gray-950">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-10 sm:gap-12 items-center">

          {/* Text — shows first on mobile */}
          <div className="text-center lg:text-left order-2 lg:order-1">
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              Project &amp; Task Management Integration
            </h2>
            <p className="text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed mb-8 sm:mb-10">
              Stay on top of every milestone with built-in project management that tracks task
              assignments, deadlines, and approvals. MentorBox replaces inefficient internal email
              chains with centralized, transparent communication — so every collaborator sees
              real-time updates instantly.
            </p>
            <div className="space-y-5 sm:space-y-6">
              {[
                { title: 'Task Tracking', desc: 'Assign tasks with clear deadlines and approval workflows' },
                { title: 'Centralized Communication', desc: 'Replace scattered emails with a single communication hub' },
                { title: 'Real-Time Transparency', desc: 'All collaborators see progress updates as they happen' },
              ].map((item) => (
                <div key={item.title} className="flex gap-4 items-start text-left">
                  <div className="w-3 h-3 bg-orange-500 rounded-full mt-1.5 flex-shrink-0"></div>
                  <div>
                    <h4 className="text-white font-bold text-sm sm:text-base lg:text-lg mb-0.5">{item.title}</h4>
                    <p className="text-gray-400 text-sm sm:text-base">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="flex items-center justify-center order-1 lg:order-2">
            <div className="rounded-2xl overflow-hidden shadow-2xl w-full max-w-lg border border-orange-500/20">
              <img
                src="/Assests/home_page_190.png"
                alt="Project & Task Management Dashboard"
                className="w-full h-auto object-cover"
                style={{ pointerEvents: 'none', userSelect: 'none', WebkitUserDrag: 'none' }}
              />
            </div>
          </div>

        </div>
      </section>

      {/* ─── Adaptive User Roles ─── */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-20 bg-black">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-6 leading-tight">
            Adaptive User Roles &amp; Group Management
          </h2>
          <p className="text-gray-300 text-sm sm:text-base lg:text-lg leading-relaxed max-w-4xl mx-auto mb-10 sm:mb-14 px-2">
            MentorBox supports the full spectrum of the startup ecosystem — mentors, founders,
            incubators, and accelerators — each with tailored permissions and views. Create
            learning groups or company teams effortlessly, and customize workflows to match your
            unique mentoring approach.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 text-left">
            {[
              {
                title: 'Multiple User Types',
                desc: 'Mentors, startups, incubators, and accelerators — all supported natively',
                icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />,
              },
              {
                title: 'Group Management',
                desc: 'Create and manage learning groups or company teams with ease',
                icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />,
              },
              {
                title: 'Custom Workflows',
                desc: 'Tailor processes to fit different mentoring styles and organizational needs',
                icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />,
              },
            ].map((item) => (
              <div key={item.title} className="flex gap-4 sm:gap-5 items-start">
                <div className="w-12 h-12 sm:w-14 sm:h-14 border-2 border-orange-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 sm:w-6 sm:h-6 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    {item.icon}
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-bold text-base sm:text-lg mb-2">{item.title}</h3>
                  <p className="text-gray-400 text-sm sm:text-base leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ─── CHAPTER 4: WHY MENTORBOX STANDS OUT ─────────────────────────── */}
      <section className="relative w-full py-12 sm:py-16 flex items-center justify-center px-4" style={{ backgroundColor: '#e07b1a' }}>
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(40)].map((_, i) => (
            <div key={i} className="absolute bg-orange-200 rounded-full"
              style={{
                width: Math.random() * 3 + 1 + 'px',
                height: Math.random() * 3 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
                opacity: Math.random() * 0.2 + 0.05,
              }}
            />
          ))}
        </div>
        <div className="relative z-10 w-full max-w-2xl bg-black/80 rounded-2xl px-6 sm:px-10 py-8 sm:py-10 shadow-2xl"
          style={{ border: '1px solid rgba(255,255,255,0.08)' }}>
          <h2 className="text-2xl sm:text-4xl lg:text-5xl font-bold text-white leading-tight text-center">
            Why MentorBox Stands Out
          </h2>
        </div>
      </section>

      {/* ─── Designed for Everyone ─── */}
      <section className="relative w-full flex items-center justify-center overflow-hidden py-10 sm:py-14 px-4">
        <div className="absolute inset-0">
          <img
            src="/Assests/home_page_183.png"
            alt="Startup Ecosystem Background"
            className="w-full h-full object-cover object-center"
            style={{ pointerEvents: 'none', userSelect: 'none', WebkitUserDrag: 'none' }}
          />
          <div className="absolute inset-0 bg-black/20" />
        </div>

        <div
          className="relative z-10 w-full max-w-2xl rounded-2xl px-5 sm:px-10 py-7 sm:py-8 shadow-2xl"
          style={{
            backgroundColor: 'rgba(10, 10, 10, 0.82)',
            border: '1px solid rgba(255,255,255,0.10)',
            backdropFilter: 'blur(6px)',
          }}
        >
          <h2 className="text-lg sm:text-2xl lg:text-3xl font-bold text-white mb-4 leading-tight">
            Designed for Everyone in the Startup Ecosystem
          </h2>
          <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
            MentorBox isn't a one-size-fits-all tool — it's purpose-built for the unique dynamics
            of startup growth. From design thinking integration via NotesBuddy to knowledge refinement
            workflows, the platform emphasizes building personal relationships as the foundation of
            lasting success.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
            {[
              {
                title: 'Startups & Founders',
                desc: 'Access mentorship tailored to your growth stage',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                    d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                ),
              },
              {
                title: 'Incubators & Accelerators',
                desc: 'Manage cohorts and track portfolio progress',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                ),
              },
              {
                title: 'Colleges & Mentors',
                desc: 'Facilitate design thinking and knowledge refinement',
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                    d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
                ),
              },
            ].map((item) => (
              <div key={item.title} className="flex flex-col items-center text-center">
                <div
                  className="w-14 h-10 flex items-center justify-center mb-3 flex-shrink-0"
                  style={{ clipPath: 'polygon(0% 0%, 82% 0%, 100% 50%, 82% 100%, 0% 100%)', backgroundColor: '#f97316' }}
                >
                  <svg className="w-5 h-5 text-black" fill="none" stroke="black" strokeWidth={1.8} viewBox="0 0 24 24">
                    {item.icon}
                  </svg>
                </div>
                <h3 className="text-white font-bold text-sm mb-1">{item.title}</h3>
                <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Security & Accessibility ─── */}
      <section className="relative px-4 sm:px-8 lg:px-20 py-12 sm:py-16 bg-black">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 items-center">

          <div className="w-full overflow-hidden rounded-xl shadow-2xl">
            <img
              src="/Assests/home_page_191.png"
              alt="Security"
              className="w-full object-cover object-top"
              style={{ pointerEvents: 'none', userSelect: 'none', WebkitUserDrag: 'none', display: 'block', height: '280px', objectFit: 'cover' }}
            />
          </div>

          <div className="flex flex-col justify-center">
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4 leading-tight">
              Security &amp; Accessibility
            </h2>
            <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
              Your data and sessions are protected with enterprise-grade security, while
              multi-device accessibility ensures mentoring happens on your terms —
              anytime, anywhere, on any device.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
              {[
                { title: 'Two-Factor Authentication', desc: 'Secure every login with an extra layer of protection' },
                { title: 'Multi-Device Access', desc: 'Desktop app, web portal, and mobile-friendly interface' },
                { title: 'Remote Collaboration', desc: 'Mentor and collaborate from anywhere in the world' },
              ].map((item) => (
                <div
                  key={item.title}
                  className="rounded-xl p-4 flex flex-col gap-2 hover:border-orange-500 transition-all duration-200"
                  style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.18)' }}
                >
                  <h4 className="text-white font-bold text-xs sm:text-sm leading-snug">{item.title}</h4>
                  <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* ── Scalability & Customization ─── */}
      <section className="relative px-4 sm:px-8 lg:px-20 py-12 sm:py-16 bg-black border-t border-gray-900">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 sm:gap-10 items-start">

          <div>
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 sm:mb-4 leading-tight">
              Scalability &amp; Customization
            </h2>
            <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-6 sm:mb-8">
              MentorBox grows with you. Whether you're a five-person startup or a 500-member
              accelerator, the platform adapts effortlessly to evolving teams and complex project needs.
            </p>
            <div className="space-y-3">
              {[
                { title: 'Flexible Scaling', desc: 'Adapts seamlessly to growing teams and projects' },
                { title: 'Custom Modules', desc: 'Configurable workflows for unique organizational needs' },
                { title: 'Multi-Language Chat', desc: 'Automated translation breaks down language barriers' },
              ].map((item) => (
                <div
                  key={item.title}
                  className="rounded-xl px-5 py-4 hover:border-orange-400 transition-all duration-200"
                  style={{ backgroundColor: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.15)', borderLeft: '3px solid #f97316' }}
                >
                  <h4 className="text-white font-bold text-sm sm:text-base mb-1">{item.title}</h4>
                  <p className="text-gray-400 text-xs sm:text-sm">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="w-full overflow-hidden rounded-xl shadow-2xl">
            <img
              src="/Assests/home_page_192.png"
              alt="Scalability"
              className="w-full h-auto object-cover object-center"
              style={{ pointerEvents: 'none', userSelect: 'none', WebkitUserDrag: 'none' }}
            />
          </div>

        </div>
      </section>

      {/* ─── CHAPTER 5: THE FUTURE ────────────────────────────────────────── */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-10 sm:py-16 bg-black">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="text-2xl sm:text-4xl lg:text-6xl font-bold text-white leading-tight">
            The Future of Mentoring with MentorBox
          </h2>
        </div>
      </section>

      {/* ─── Continuous Innovation ─── */}
      <section className="relative px-4 sm:px-8 lg:px-24 py-12 sm:py-16 bg-black border-t border-gray-900">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(60)].map((_, i) => (
            <div key={i} className="absolute bg-white rounded-full"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
                opacity: Math.random() * 0.3 + 0.05,
              }}
            />
          ))}
        </div>

        <div className="relative z-10 max-w-3xl mx-auto text-center">
          <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 sm:mb-5 leading-tight">
            Continuous Innovation &amp; User-Centric Development
          </h2>
          <p className="text-gray-300 text-sm sm:text-base leading-relaxed mb-10 sm:mb-12 px-2">
            MentorBox is committed to evolving alongside its users. With ongoing enhancements driven
            by real feedback and emerging technologies, the platform is shaping the future of
            mentorship — making it smarter, more personalized, and accessible to all.
          </p>

          {/* Three overlapping orange circles */}
          <div className="flex items-center justify-center mb-3">
            {[
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                    d="M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z" />
                ),
              },
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                    d="M4.5 12a7.5 7.5 0 0015 0m-15 0a7.5 7.5 0 1115 0m-15 0H3m16.5 0H21m-1.5 0H12m-8.457 3.077l1.41-.513m14.095-5.13l1.41-.513M5.106 17.785l1.15-.964m11.49-9.642l1.149-.964M7.501 19.795l.75-1.3m7.5-12.99l.75-1.3m-6.063 16.658l.26-1.477m2.605-14.772l.26-1.477m0 17.726l-.26-1.477M10.698 4.614l-.26-1.477M16.5 19.794l-.75-1.299M7.5 4.205L12 12m6.894 5.785l-1.149-.964M6.256 7.178l-1.15-.964m15.352 8.864l-1.41-.513M4.954 9.435l-1.41-.514M12.002 12l-3.75 6.495" />
                ),
              },
              {
                icon: (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}
                    d="M12 18v-5.25m0 0a6.01 6.01 0 001.5-.189m-1.5.189a6.01 6.01 0 01-1.5-.189m3.75 7.478a12.06 12.06 0 01-4.5 0m3.75 2.355a3.375 3.375 0 01-3 0m1.5-15.25a4.5 4.5 0 100 9 4.5 4.5 0 000-9z" />
                ),
              },
            ].map((item, i) => (
              <div key={i} className="flex items-center">
                <div
                  className="flex items-center justify-center rounded-full flex-shrink-0"
                  style={{
                    width: '90px',
                    height: '90px',
                    border: '3px solid #f97316',
                    backgroundColor: 'rgba(249,115,22,0.07)',
                    marginLeft: i > 0 ? '-12px' : '0',
                    zIndex: 3 - i,
                    position: 'relative',
                  }}
                >
                  <svg className="w-8 h-8" fill="none" stroke="#f97316" viewBox="0 0 24 24">
                    {item.icon}
                  </svg>
                </div>
                {i < 2 && (
                  <div className="flex-shrink-0 font-bold text-orange-500 text-xl" style={{ position: 'relative', zIndex: 10, margin: '0 -2px' }}>
                    &#8250;
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Labels */}
          <div className="flex justify-center mb-10" style={{ gap: '8px' }}>
            {[
              { line1: 'User', line2: 'Feedback' },
              { line1: 'Platform', line2: 'Enhancements' },
              { line1: 'AI', line2: 'Personalization' },
            ].map((item, i) => (
              <div key={i} className="text-center font-bold text-white text-xs sm:text-sm leading-tight" style={{ width: '90px' }}>
                <div>{item.line1}</div>
                <div>{item.line2}</div>
              </div>
            ))}
          </div>

          <p className="text-gray-300 text-xs sm:text-sm leading-relaxed max-w-2xl mx-auto px-2">
            By integrating AI and advanced analytics, MentorBox will deliver increasingly personalized
            mentoring experiences — matching startups with the right mentors, surfacing relevant
            resources, and tracking progress with intelligent insights.
          </p>
        </div>
      </section>

      {/* ─── JOIN COMMUNITY CTA ─── */}
      <section className="relative px-4 sm:px-10 lg:px-20 py-12 sm:py-16 bg-black overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(70)].map((_, i) => (
            <div key={i} className="absolute bg-white rounded-full"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
                opacity: Math.random() * 0.35 + 0.08,
              }}
            />
          ))}
        </div>

        <div className="max-w-6xl mx-auto relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          <div>
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight">
              Join the MentorBox Community Today
            </h2>
            <p className="text-gray-300 text-sm leading-relaxed mb-6 sm:mb-8 max-w-md">
              Experience the platform that's transforming how startups and mentors connect,
              collaborate, and succeed. Getting started is easy — and our team is with you
              every step of the way.
            </p>

            <div className="space-y-4 sm:space-y-5 mb-6 sm:mb-8">
              {[
                { title: 'Try the Free Demo', desc: "Experience MentorBox's full capabilities firsthand with no commitment" },
                { title: 'Get 24/7 Support', desc: 'Dedicated onboarding assistance ensures a smooth start for your team' },
                { title: 'Empower Your Program', desc: 'Launch your all-in-one mentoring and management solution' },
              ].map((item) => (
                <div key={item.title} className="flex gap-4 items-start">
                  <div className="flex-shrink-0 w-8 h-8 sm:w-9 sm:h-9 border-2 border-orange-500 rounded flex items-center justify-center mt-0.5">
                    <svg className="w-4 h-4 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                  <div>
                    <h4 className="text-white font-bold text-sm mb-0.5">{item.title}</h4>
                    <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <button className="px-6 py-3 bg-orange-500 text-black font-bold text-sm rounded-lg hover:bg-orange-400 transition">
              Start Your Free Demo
            </button>
          </div>

          <div className="rounded-2xl overflow-hidden h-64 sm:h-80 lg:h-96">
            <img
              src="/Assests/home_page_193.png"
              alt="MentorBox Community"
              className="w-full h-full object-cover object-center"
              style={{ filter: 'brightness(0.85)' }}
            />
          </div>

        </div>
      </section>

      {/* ─── FINAL CTA ──────────────── */}
      <section className="relative px-4 sm:px-10 lg:px-20 py-12 sm:py-16 bg-black overflow-hidden">
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          {[...Array(70)].map((_, i) => (
            <div key={i} className="absolute bg-white rounded-full"
              style={{
                width: Math.random() * 2 + 1 + 'px',
                height: Math.random() * 2 + 1 + 'px',
                top: Math.random() * 100 + '%',
                left: Math.random() * 100 + '%',
                opacity: Math.random() * 0.35 + 0.08,
              }}
            />
          ))}
        </div>

        <div className="max-w-6xl mx-auto relative z-10 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">

          {/* Image — bottom on mobile */}
          <div className="flex items-center justify-center order-2 lg:order-1">
            <div className="w-full max-w-xs sm:max-w-sm lg:max-w-md h-64 sm:h-80 lg:h-[28rem] rounded-2xl overflow-hidden">
              <img
                src="/Assests/home_page_194.png"
                alt="Ready to Transform"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          {/* Text — top on mobile */}
          <div className="order-1 lg:order-2">
            <h2 className="text-xl sm:text-3xl lg:text-4xl font-bold text-white mb-4 leading-tight">
              Ready to Transform Your Mentoring Experience?
            </h2>
            <p className="text-gray-300 text-sm leading-relaxed mb-6 sm:mb-7">
              Visit{' '}
              <a href="https://mentorbox.net.in" target="_blank" rel="noopener noreferrer" className="text-orange-500 font-semibold hover:underline">
                mentorbox.net.in
              </a>{' '}
              to get started. Connect with expert mentors, manage projects efficiently, and
              accelerate your growth trajectory.
            </p>

            <div className="grid grid-cols-2 gap-3 mb-3">
              {[
                { title: 'Connect', desc: 'Access a network of expert mentors across industries' },
                { title: 'Manage', desc: 'Track projects, tasks, and milestones in one place' },
              ].map((item) => (
                <div key={item.title} className="bg-gray-900 border border-orange-500/50 rounded-xl p-3 sm:p-4">
                  <h4 className="text-white font-bold text-sm mb-1 sm:mb-2">{item.title}</h4>
                  <p className="text-gray-400 text-xs leading-relaxed">{item.desc}</p>
                </div>
              ))}
            </div>

            <div className="bg-gray-900 border border-orange-500/50 rounded-xl p-3 sm:p-4 mb-5 sm:mb-7">
              <h4 className="text-white font-bold text-sm mb-1 sm:mb-2">Succeed</h4>
              <p className="text-gray-400 text-xs leading-relaxed">Where startups and mentors thrive together</p>
            </div>

            <div className="flex flex-wrap gap-3">
              {hasRefAccess && (
                <button
                  onClick={() => navigate('/reffrence?productId=5')}
                  className="px-5 py-2.5 sm:px-6 sm:py-3 bg-orange-500 text-white text-sm font-semibold rounded-lg hover:bg-orange-600 transition flex items-center gap-2"
                >
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  Reference
                </button>
              )}
              <button
                onClick={() => navigate('/reffrence?productId=5')}
                className="px-5 py-2.5 sm:px-6 sm:py-3 bg-orange-500 text-white text-sm font-semibold rounded-lg hover:bg-orange-600 transition"
              >
                Get Started Now
              </button>
              <button
                onClick={() => navigate('/reffrence?productId=5')}
                className="px-5 py-2.5 sm:px-6 sm:py-3 border-2 border-white text-white text-sm font-semibold rounded-lg hover:bg-white hover:text-orange-500 transition"
              >
                Contact Us
              </button>
            </div>
          </div>

        </div>
      </section>

    </div>
  );
}

export default MentorBox;